import { skipToken, useQuery } from '@tanstack/react-query';

import { connectedAppsQueryKeys } from '../../contracts/queryKeys';
import type {
  GetIntegrationOnboardingSessionsQueryParams,
  SearchIntegrationOnboardingSessionsResponse,
} from '../../contracts/types';
import { getIntegrationOnboardingSessions } from '../api/onboarding-sessions';

/** Only truthiness is read from each term; `user` must not be narrowed to an id. */
export interface IntegrationOnboardingSessionsIdentity {
  isAuthenticated: boolean;
  region: string | null | undefined;
  user: unknown;
}

/** Reads the integration onboarding sessions list, filtered by `params`. `enabled` gates independently of the identity terms. */
export const useQueryIntegrationOnboardingSessions = <
  T = SearchIntegrationOnboardingSessionsResponse,
>({
  params,
  select,
  enabled,
  isAuthenticated,
  region,
  user,
}: {
  params: GetIntegrationOnboardingSessionsQueryParams;
  select?: (data: SearchIntegrationOnboardingSessionsResponse) => T;
  enabled?: boolean;
} & IntegrationOnboardingSessionsIdentity) => {
  return useQuery({
    queryKey: connectedAppsQueryKeys.onboardingSessions(params),
    queryFn: Boolean(isAuthenticated && region && user)
      ? async () => {
          const data = await getIntegrationOnboardingSessions({ params });
          return data;
        }
      : skipToken,
    enabled,
    select,
  });
};
